/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { EBannerPosition } from "../types/EBannerPosition.ts";

/**
 * @description 1 = Top | 2 = MiddleStart | 3 = MiddleEnd | 4 = Bottom |
 */
export const eBannerPositionSchema = z
  .union([z.literal(1), z.literal(2), z.literal(3), z.literal(4)])
  .describe(
    "1 = Top | 2 = MiddleStart | 3 = MiddleEnd | 4 = Bottom | ",
  ) as unknown as ToZod<EBannerPosition>;
